const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.PRODUCTION_SOCKETS)

export const apiProductionSockets = {
	fetchProductionSockets: async (
		search: string | undefined,
		page: number = 1,
		perPage: number = 25,
	): Promise<IApiResponseModel<IProductionSocketModel[]>> => {
		const { data, meta } = await apiCommon<IProductionSocket[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { name: search }),
		})

		return { data: data.map(d => ProductionSocket(d)), meta }
	},

	fetchProductionSocketByID: async (id: number): Promise<IApiResponseModel<IProductionSocketModel>> => {
		const { data, meta } = await apiCommon<IProductionSocket>(`${groupPrefix}/${id}`, {
			method: 'GET',
		})

		return { data: ProductionSocket(data), meta }
	},

	createProductionSocket: async (
		payload: IProductionSocketCreatePayload,
	): Promise<IApiResponseModel<IProductionSocketModel>> => {
		const { data, meta } = await apiCommon<IProductionSocket>(`${groupPrefix}`, {
			method: 'POST',
			body: payload,
		})

		return { data: ProductionSocket(data), meta }
	},

	updateProductionSocket: async (
		payload: IProductionSocketUpdatePayload,
	): Promise<IApiResponseModel<IProductionSocketModel>> => {
		const { data, meta } = await apiCommon<IProductionSocket>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return { data: ProductionSocket(data), meta }
	},

	fetchBasicProductionMachines: async (): Promise<IApiResponseModel<IProductionSocketStageMachineModel[]>> => {
		const { data } = await apiCommon<IProductionSocketStageMachine[]>(`${groupPrefix}/machines`, {
			method: 'GET',
		})

		return { data }
	},

	fetchDetailsProductionMachines: async (): Promise<IProductionSocketDetailsModel[]> => {
		const { data } = await apiCommon<IProductionSocketDetails[]>(`${groupPrefix}/details`, {
			method: 'GET',
		})

		return data.map(ProductionSocketDetails)
	},
}
